import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  somethingWentWrong: {
    id: 't.somethingWentWrong',
    defaultMessage: 'Something Went Wrong',
  },
  errorDescription: {
    id: 't.errorDescription',
    defaultMessage: 'Error Description:',
  },
  infoStack: {
    id: 't.infoStack',
    defaultMessage: 'Stack:',
  },
  refreshPrompt: {
    id: 't.refreshPrompt',
    defaultMessage: 'Please fix the problem and refresh.',
  },
  inspiringQuote: {
    id: 't.inspiringQuote',
    defaultMessage:
      '“Sometimes I’ll start a line of code and I don’t even know where it’s going. I just hope I find it along the way.” – Michael Scott',
  },
});
